import { useEffect } from "react";

const StatusEmbedLoader = () => {
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://zv7r9jf6v0g6.statuspage.io/embed/script.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://status.duon-portal.de/embed/script.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      script.onload = () => {
        console.log("Statuspage embed script loaded");
      };
      script.onerror = () => {
        console.error("❌ Failed to load Statuspage embed script");
      };
    }
  }, []);

  return null; // Nothing visible; it just loads the script
};

export default StatusEmbedLoader;
